<div class="container">
  <sca-module-title class="title-test">
    <h1>Config Playground</h1>
    <span scaModuleTitlePost>Testing exhaustivo de @argo/config - {{ coverage }}% de cobertura</span>
  </sca-module-title>

  <!-- 1. ESTADO Y FASE -->
  <section class="card">
    <h2>Estado de Configuración</h2>
    
    <sca-alert variant="info" style="margin-bottom: 1.5rem;">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      ConfigStore utiliza CommonPhase para gestionar el ciclo de vida de carga de configuración
    </sca-alert>

    <div class="status-grid">
      <sca-card-workshop [selected]="config.phase$() === CommonPhase.IDLE">
        <header scaCardWorkshopHeader>
          <sca-badge variant="default" [rounded]="false">Sin cargar</sca-badge>
        </header>
        <p scaCardWorkshopTitle>Estado inicial</p>
        <p scaCardWorkshopAddress>IDLE</p>
      </sca-card-workshop>

      <sca-card-workshop [selected]="config.phase$() === CommonPhase.LOADING">
        <header scaCardWorkshopHeader>
          <sca-badge variant="warning" [rounded]="false">Cargando...</sca-badge>
        </header>
        <p scaCardWorkshopTitle>Fetching config</p>
        <p scaCardWorkshopAddress>LOADING</p>
      </sca-card-workshop>

      <sca-card-workshop [selected]="config.phase$() === CommonPhase.LOADED">
        <header scaCardWorkshopHeader>
          <sca-badge variant="success" [rounded]="false">Cargado OK</sca-badge>
        </header>
        <p scaCardWorkshopTitle>Config disponible</p>
        <p scaCardWorkshopAddress>LOADED</p>
      </sca-card-workshop>

      <sca-card-workshop [selected]="config.phase$() === CommonPhase.ERROR">
        <header scaCardWorkshopHeader>
          <sca-badge variant="error" [rounded]="false">Error</sca-badge>
        </header>
        <p scaCardWorkshopTitle>Falló la carga</p>
        <p scaCardWorkshopAddress>ERROR</p>
      </sca-card-workshop>
    </div>

    <div *ngIf="config.error$()" style="margin-top: 1rem;">
      <sca-alert variant="error">
        <sca-icon icon="error" size="24px" [weight]="300" left />
        <strong>Error:</strong> {{ config.error$() }}
      </sca-alert>
    </div>
  </section>

  <!-- 2. SIGNALS Y COMPUTED -->
  <section class="card">
    <h2>Signals y Computed Properties</h2>
    
    <sca-alert variant="info" style="margin-bottom: 1.5rem;">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      Todas las propiedades reactivas del ConfigStore
    </sca-alert>

    <table class="properties-table">
      <thead>
        <tr>
          <th>Propiedad</th>
          <th>Tipo</th>
          <th>Valor Actual</th>
          <th>Descripción</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><code>phase$()</code></td>
          <td>Computed&lt;CommonPhase&gt;</td>
          <td><sca-badge variant="accent">{{ config.phase$() }}</sca-badge></td>
          <td>Estado de carga de la config</td>
        </tr>
        <tr>
          <td><code>configPath$()</code></td>
          <td>Computed&lt;string&gt;</td>
          <td><code>{{ config.configPath$() }}</code></td>
          <td>Ruta de assets de config</td>
        </tr>
        <tr>
          <td><code>configurationProperties$()</code></td>
          <td>Computed&lt;ArgoConfig&gt;</td>
          <td><sca-badge variant="default">Object ({{ jsonSize }} bytes)</sca-badge></td>
          <td>Config completa de la app</td>
        </tr>
        <tr>
          <td><code>error$()</code></td>
          <td>Computed&lt;unknown|null&gt;</td>
          <td>
            <sca-badge [variant]="config.error$() ? 'error' : 'success'">
              {{ config.error$() || 'null' }}
            </sca-badge>
          </td>
          <td>Error de carga si existe</td>
        </tr>
      </tbody>
    </table>
  </section>

  <!-- 3. MÉTODOS PÚBLICOS -->
  <section class="card">
    <h2>Métodos Públicos</h2>
    
    <sca-alert variant="info" style="margin-bottom: 1.5rem;">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      Funciones disponibles para gestionar la configuración
    </sca-alert>

    <div class="button-grid">
      <button sca-button variant="primary" size="medium" (click)="loadConfig()" [disabled]="isLoading">
        <sca-icon icon="refresh" size="20"></sca-icon>
        {{ isLoading ? 'Cargando...' : 'Recargar Config' }}
      </button>
      
      <button sca-button variant="border" size="medium" (click)="showCurrentConfig()">
        <sca-icon icon="visibility" size="20"></sca-icon>
        Ver Config Actual
      </button>
      
      <button sca-button variant="primary" size="medium" (click)="runValidation()">
        <sca-icon icon="check_circle" size="20"></sca-icon>
        Validar Config
      </button>
    </div>

    <div *ngIf="loadResult" style="margin-top: 1.5rem;">
      <sca-alert [variant]="loadResult.error ? 'error' : 'success'">
        <sca-icon [icon]="loadResult.error ? 'error' : 'check_circle'" size="24px" [weight]="300" left />
        {{ loadResult.error ? 'Error: ' + loadResult.error : 'Config cargada correctamente' }}
      </sca-alert>
    </div>

    <div *ngIf="validationResult" style="margin-top: 1.5rem;">
      <sca-alert [variant]="validationResult.success ? 'success' : 'error'">
        <sca-icon [icon]="validationResult.success ? 'check_circle' : 'error'" size="24px" [weight]="300" left />
        {{ validationResult.success ? 'Validación exitosa' : 'Error: ' + validationResult.error }}
      </sca-alert>
    </div>

    <div *ngIf="currentConfig" style="margin-top: 1.5rem;">
      <sca-view-more [collapsedText]="currentConfigCollapsed" [expandedText]="currentConfigExpanded" [isExpanded]="false">
        <pre>{{ currentConfig | json }}</pre>
      </sca-view-more>
    </div>
  </section>

  <!-- 4. ARGOCONFIG COMPLETO -->
  <section class="card">
    <h2>Configuración Completa (ArgoConfig)</h2>

 <sca-alert variant="info" style="margin-bottom: 1.5rem;">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      Configuración Completa - Todas las propiedades de la interfaz ArgoConfig
    </sca-alert>
    
    <h3>Propiedades Principales</h3>
    <div class="utilities-grid">
      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="label" size="24px" />
        <span scaCardClaimTitle>App Name</span>
        <span scaCardClaimDate>{{ appConfig.arq.appName || 'N/A' }}</span>
      </sca-card-claim>
      
      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="settings" size="24px" />
        <span scaCardClaimTitle>Production</span>
        <span scaCardClaimDate>{{ appConfig.arq.production ? '✓ Sí' : '✗ No' }}</span>
      </sca-card-claim>
      
      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="dns" size="24px" />
        <span scaCardClaimTitle>Env</span>
        <span scaCardClaimDate>{{ appConfig.arq.env || 'N/A' }}</span>
      </sca-card-claim>
      
      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="public" size="24px" />
        <span scaCardClaimTitle>Exposure</span>
        <span scaCardClaimDate>{{ appConfig.arq.exposure || 'N/A' }}</span>
      </sca-card-claim>
      
      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="folder" size="24px" />
        <span scaCardClaimTitle>Directory Active</span>
        <span scaCardClaimDate>{{ appConfig.arq.directoryActive || 'N/A' }}</span>
      </sca-card-claim>
    </div>

    <h3 style="margin-top: 2rem;">ARQ - Security Configuration</h3>
    <div class="utilities-grid">
      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="key" size="24px" />
        <span scaCardClaimTitle>Client ID</span>
        <span scaCardClaimDate>{{ appConfig.arq.security.credentials.clientId || 'N/A' }}</span>
      </sca-card-claim>
    </div>

    <h3 style="margin-top: 2rem;">ARQ - Traces Configuration</h3>
    <div class="utilities-grid">
      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="bar_chart" size="24px" />
        <span scaCardClaimTitle>Log Level</span>
        <span scaCardClaimDate>{{ appConfig.arq.traces.logLevel || 'N/A' }}</span>
      </sca-card-claim>
      
      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="link" size="24px" />
        <span scaCardClaimTitle>Trace URL</span>
        <span scaCardClaimDate>{{ appConfig.arq.traces.url || 'Construida dinámicamente' }}</span>
      </sca-card-claim>
    </div>

    <div *ngIf="appConfig.arq.authentication">
      <h3 style="margin-top: 2rem;">ARQ - Authentication Configuration</h3>
      
      <h4 style="margin-top: 1rem; margin-bottom: 0.5rem;">Token Refresh Settings (Obligatorio)</h4>
      <div class="utilities-grid">
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="refresh" size="24px" />
          <span scaCardClaimTitle>Refreshable</span>
          <span scaCardClaimDate>{{ appConfig.arq.authentication.refreshable ? '✓ Sí' : '✗ No' }}</span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="list" size="24px" />
          <span scaCardClaimTitle>Refresh Types</span>
          <span scaCardClaimDate>{{ appConfig.arq.authentication.refreshTypes.join(', ') || 'N/A' }}</span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="schedule" size="24px" />
          <span scaCardClaimTitle>Refresh Time</span>
          <span scaCardClaimDate>{{ appConfig.arq.authentication.refreshTime }}s</span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="touch_app" size="24px" />
          <span scaCardClaimTitle>By User Activity</span>
          <span scaCardClaimDate>{{ appConfig.arq.authentication.refreshTimeByUserActivity }}s</span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="build" size="24px" />
          <span scaCardClaimTitle>By Custom Action</span>
          <span scaCardClaimDate>{{ appConfig.arq.authentication.refreshTimeByCustomAction }}s</span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="block" size="24px" />
          <span scaCardClaimTitle>No Refreshable</span>
          <span scaCardClaimDate>{{ appConfig.arq.authentication.refreshTimeNoRefreshable }}s</span>
        </sca-card-claim>
      </div>

      <div *ngIf="appConfig.arq.authentication.guard">
        <h4 style="margin-top: 1.5rem; margin-bottom: 0.5rem;">Guard Settings (Opcional)</h4>
        <div class="utilities-grid">
          <sca-card-claim>
            <sca-icon scaCardClaimIcon icon="route" size="24px" />
            <span scaCardClaimTitle>Redirect Route</span>
            <span scaCardClaimDate>{{ appConfig.arq.authentication.guard.route || 'Default: /login' }}</span>
          </sca-card-claim>
          
          <sca-card-claim>
            <sca-icon scaCardClaimIcon icon="timer" size="24px" />
            <span scaCardClaimTitle>Sync Timeout</span>
            <span scaCardClaimDate>{{ appConfig.arq.authentication.guard.syncTimeout || '5000' }}ms</span>
          </sca-card-claim>
          
          <sca-card-claim>
            <sca-icon scaCardClaimIcon icon="hourglass_empty" size="24px" />
            <span scaCardClaimTitle>Authenticating Timeout</span>
            <span scaCardClaimDate>{{ appConfig.arq.authentication.guard.authenticatingTimeout || '5000' }}ms</span>
          </sca-card-claim>
          
          <sca-card-claim>
            <sca-icon scaCardClaimIcon icon="timer_off" size="24px" />
            <span scaCardClaimTitle>Final Sync Timeout</span>
            <span scaCardClaimDate>{{ appConfig.arq.authentication.guard.finalSyncTimeout || '2000' }}ms</span>
          </sca-card-claim>
        </div>
      </div>

      <div *ngIf="appConfig.arq.authentication.sso">
        <h4 style="margin-top: 1.5rem; margin-bottom: 0.5rem;">SSO Custom Overrides (Opcional)</h4>
        <div class="utilities-grid">
          <sca-card-claim>
            <sca-icon scaCardClaimIcon icon="login" size="24px" />
            <span scaCardClaimTitle>Login Domain</span>
            <span scaCardClaimDate>{{ appConfig.arq.authentication.sso.customDomains?.loginDomain || 'Default (mapped)' }}</span>
          </sca-card-claim>
          
          <sca-card-claim>
            <sca-icon scaCardClaimIcon icon="api" size="24px" />
            <span scaCardClaimTitle>API Domain</span>
            <span scaCardClaimDate>{{ appConfig.arq.authentication.sso.customDomains?.apiDomain || 'Default (mapped)' }}</span>
          </sca-card-claim>
          
          <sca-card-claim>
            <sca-icon scaCardClaimIcon icon="domain" size="24px" />
            <span scaCardClaimTitle>Custom Realm</span>
            <span scaCardClaimDate>{{ appConfig.arq.authentication.sso.customRealm || 'Default (mapped)' }}</span>
          </sca-card-claim>
        </div>
      </div>
    </div>

    <div *ngIf="appConfig.arq.session">
      <h3 style="margin-top: 2rem;">ARQ - Session Configuration (Opcional)</h3>
      <div class="utilities-grid">
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="sync" size="24px" />
          <span scaCardClaimTitle>Sync Interval</span>
          <span scaCardClaimDate>{{ appConfig.arq.session.syncInterval || '15' }} segundos</span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="check_circle" size="24px" />
          <span scaCardClaimTitle>Enable Sync</span>
          <span scaCardClaimDate>{{ appConfig.arq.session.enableSync !== false ? '✓ Sí' : '✗ No' }}</span>
        </sca-card-claim>
      </div>
    </div>

    <div *ngIf="appConfig.arq.messaging">
      <h3 style="margin-top: 2rem;">ARQ - Messaging Configuration</h3>
      
      <h4 style="margin-top: 1rem; margin-bottom: 0.5rem;">WebSocket Settings (Obligatorio si se usa messaging)</h4>
      <div class="utilities-grid">
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="power" size="24px" />
          <span scaCardClaimTitle>WebSocket Base URL</span>
          <span scaCardClaimDate>{{ appConfig.arq.messaging.websocketBaseUrl || 'N/A' }}</span>
        </sca-card-claim>
      </div>

      <h4 style="margin-top: 1.5rem; margin-bottom: 0.5rem;">Reconnect Settings (Opcional)</h4>
      <div class="utilities-grid">
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="restore" size="24px" />
          <span scaCardClaimTitle>Reconnect Delay</span>
          <span scaCardClaimDate>{{ appConfig.arq.messaging.reconnectDelay || '5000' }}ms</span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="repeat" size="24px" />
          <span scaCardClaimTitle>Retry Interval</span>
          <span scaCardClaimDate>{{ appConfig.arq.messaging.retryInterval || '200' }}ms</span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="filter_9_plus" size="24px" />
          <span scaCardClaimTitle>Max Reconnect Attempts</span>
          <span scaCardClaimDate>{{ appConfig.arq.messaging.maxReconnectAttempts || '10' }} intentos</span>
        </sca-card-claim>
      </div>
    </div>

    <div *ngIf="appConfig.trustedOrigins" style="margin-top: 2rem;">
      <h3>Trusted Origins (Opcional)</h3>
      <div class="origins-list">
        <sca-badge variant="success" *ngFor="let origin of appConfig.trustedOrigins">
          🔒 {{ origin }}
        </sca-badge>
      </div>
    </div>
  </section>

  <!-- 5. VALIDADORES -->
  <section class="card">
    <h2>Validadores de Configuración</h2>
    <sca-alert variant="info" style="margin-bottom: 1.5rem;">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      Sistema de validación automática con reglas personalizables
      
    </sca-alert>

    <!-- Validar config actual -->
    <div style="margin-bottom: 1.5rem;">
      <button sca-button (click)="runValidation()">
        <sca-icon icon="verified" size="20px" left />
        Validar Configuración Actual
      </button>
      <sca-alert *ngIf="validationResult" [variant]="validationResult.success ? 'success' : 'error'" style="margin-top: 1rem;">
        <sca-icon [icon]="validationResult.success ? 'check_circle' : 'error'" size="24px" [weight]="300" left />
        <strong>{{ validationResult.success ? '✅ Validación OK' : '❌ Errores de Validación' }}</strong>
        <pre *ngIf="validationResult.error" style="margin-top: 0.5rem; white-space: pre-wrap;">{{ validationResult.error }}</pre>
      </sca-alert>
    </div>

    <!-- Reglas activas -->
    <div style="margin-bottom: 1.5rem;">
      <h4 style="margin-bottom: 1rem;">Reglas de Validación Activas</h4>
      <div class="utilities-grid">
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="verified_user" size="24px" />
          <span scaCardClaimTitle>clientId</span>
          <span scaCardClaimDate>✅ OBLIGATORIO - arq.security.credentials.clientId</span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="public" size="24px" />
          <span scaCardClaimTitle>env</span>
          <span scaCardClaimDate>✅ OBLIGATORIO - debe ser DEV, PRE o PRO</span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="visibility" size="24px" />
          <span scaCardClaimTitle>exposure</span>
          <span scaCardClaimDate>✅ OBLIGATORIO - debe ser INTERNET o INTRANET</span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="folder" size="24px" />
          <span scaCardClaimTitle>directoryActive</span>
          <span scaCardClaimDate>✅ OBLIGATORIO - debe ser válido (INTERNO, EXTERNO, etc.)</span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="apps" size="24px" />
          <span scaCardClaimTitle>appName</span>
          <span scaCardClaimDate>✅ OBLIGATORIO - nombre de la aplicación</span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="login" size="24px" />
          <span scaCardClaimTitle>authentication</span>
          <span scaCardClaimDate>⭕ OPCIONAL - estructura completa de autenticación</span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="webhook" size="24px" />
          <span scaCardClaimTitle>websocketBaseUrl</span>
          <span scaCardClaimDate>⭕ OPCIONAL - URL WebSocket (wss:// o ws://)</span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="security" size="24px" />
          <span scaCardClaimTitle>guard settings</span>
          <span scaCardClaimDate>⭕ OPCIONAL - timeouts configurables (defaults: 5000/5000/2000ms)</span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="sync" size="24px" />
          <span scaCardClaimTitle>session sync</span>
          <span scaCardClaimDate>⭕ OPCIONAL - intervalo y habilitación (default: 15s, true)</span>
        </sca-card-claim>
      </div>
    </div>

    <!-- Añadir regla custom -->
  </section>

  <!-- 6. CONFIG INTERCEPTOR -->
  <section class="card">
    <h2>Config Interceptor (HTTP)</h2>
    <sca-alert variant="warning" style="margin-bottom: 1.5rem;">
      <sca-icon icon="http" size="24px" [weight]="300" left />
      Interceptor que añade headers automáticos a peticiones HTTP
    </sca-alert>

    <!-- Config Interceptor -->
    <div style="margin-bottom: 1.5rem;">
      <h4 style="margin-bottom: 0.5rem;">configInterceptor</h4>
      <p style="margin-bottom: 1rem;">Añade headers automáticamente a peticiones que incluyan '.sca' (excepto login)</p>

      <h5 style="margin-bottom: 1rem;">Headers Añadidos Automáticamente</h5>
      <div class="utilities-grid">
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="vpn_key" size="24px" />
          <span scaCardClaimTitle>X-IBM-Client-Id</span>
          <span scaCardClaimDate><code>{{ appConfig.arq.security.credentials.clientId }}</code></span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="fingerprint" size="24px" />
          <span scaCardClaimTitle>X-Adeslas-UUID</span>
          <span scaCardClaimDate><code>UUID generado (v4)</code></span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="devices" size="24px" />
          <span scaCardClaimTitle>X-Adeslas-Device</span>
          <span scaCardClaimDate><code>DESKTOP</code></span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="router" size="24px" />
          <span scaCardClaimTitle>channel</span>
          <span scaCardClaimDate><code>{{ channel }}</code></span>
        </sca-card-claim>
        
        <sca-card-claim>
          <sca-icon scaCardClaimIcon icon="apps" size="24px" />
          <span scaCardClaimTitle>applicationid</span>
          <span scaCardClaimDate><code>{{ appConfig.arq.appName }}</code></span>
        </sca-card-claim>
      </div>
    </div>

    <!-- Detección de canal -->
    

    <!-- Uso del interceptor -->
  </section>

  <!-- 7. JSON COMPLETO -->
  <section class="card">
    <h2>Configuración JSON Completa</h2>
 <sca-alert variant="info" style="margin-bottom: 1.5rem;">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      Vista completa de la configuración actual en formato JSON
      
    </sca-alert>
    <sca-view-more [collapsedText]="jsonCollapsed" [expandedText]="jsonExpanded" [isExpanded]="false">
      <pre>{{ appConfig | json }}</pre>
    </sca-view-more>
  </section>

  <!-- 8. RESUMEN DE COBERTURA -->
  
</div>
